import { HealthUnitRelationStruct } from "../../structs/integration-relation-config/health-unit-relation.struct";

export class VerifyHealthUnitHasIntegrationRequest {
    public listIdHealthUnit: number[] = [];
}